import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ShieldCheck, Clock, XCircle, Loader2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { API } from '../components/join/joinConfig';

const STATUS = {
  approved: { icon: ShieldCheck, cls: 'bg-green-100 text-green-700 border-green-200', label: { en: 'VERIFIED MEMBER', bn: 'যাচাইকৃত সদস্য' } },
  pending: { icon: Clock, cls: 'bg-amber-100 text-amber-700 border-amber-200', label: { en: 'REGISTERED — PENDING VERIFICATION', bn: 'নিবন্ধিত — যাচাই অপেক্ষমাণ' } },
  rejected: { icon: XCircle, cls: 'bg-red-100 text-red-700 border-red-200', label: { en: 'NOT VALID', bn: 'বৈধ নয়' } },
};

export default function VerifyMember() {
  const { memberNumber } = useParams();
  const { t } = useLanguage();
  const [m, setM] = useState(undefined);

  useEffect(() => {
    fetch(`${API}/verify/${memberNumber}`).then(r => (r.ok ? r.json() : null)).then(setM).catch(() => setM(null));
  }, [memberNumber]);

  const s = m && (STATUS[m.status] || STATUS.pending);
  return (
    <div className="min-h-[70vh] bg-gray-50 px-4 py-16" data-testid="verify-member-page">
      <div className="mx-auto max-w-md rounded-3xl bg-white p-8 text-center shadow-xl">
        <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-party-green">{t({ en: 'NDP Member Verification', bn: 'এনডিপি সদস্য যাচাই' })}</p>
        {m === undefined && <Loader2 className="mx-auto h-8 w-8 animate-spin text-party-red" />}
        {m === null && (
          <div data-testid="verify-not-found">
            <XCircle className="mx-auto mb-3 h-12 w-12 text-red-500" />
            <p className="font-bold text-gray-900">{t({ en: 'No member found with this ID', bn: 'এই আইডিতে কোনো সদস্য পাওয়া যায়নি' })}</p>
            <p className="mt-1 text-sm text-gray-500">{memberNumber}</p>
          </div>
        )}
        {m && (
          <div data-testid="verify-result">
            <s.icon className="mx-auto mb-4 h-14 w-14 text-party-green" />
            <h1 className="text-2xl font-bold text-gray-900" data-testid="verify-name">{m.full_name}</h1>
            <p className="text-sm text-gray-500">{m.district || 'Bangladesh'}</p>
            <p className="mt-3 font-mono text-lg font-bold tracking-wider text-party-red" data-testid="verify-number">{m.member_number}</p>
            <span className={`mt-4 inline-block rounded-full border px-4 py-1.5 text-xs font-bold ${s.cls}`} data-testid="verify-status">{t(s.label)}</span>
            {m.created_at && <p className="mt-4 text-xs text-gray-400">{t({ en: 'Member since', bn: 'সদস্য হয়েছেন' })} {new Date(m.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
